export default __webpack_public_path__ + "static/media/newslide2.f271d068.jpg";